import { useAuth } from '@/hooks/useAuth';
import { SettingsLayout } from '@/components/crm/settings';

export default function CRMSettings() {
  const { hasRole } = useAuth();
  const isSuperAdmin = hasRole('super_admin');

  return <SettingsLayout showSystemTab={isSuperAdmin} />;
}
